
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/government/[category]",
      function () {
        return require("private-next-pages/government/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/government/[category]"])
      });
    }
  